import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import Constants from '../../../definitions/constants';
import TableDescriptors from '../../../definitions/tableDescriptors';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import FormatTooling from '../../../tooling/formatTooling';
import EntityTableTooling from '../../../tooling/entityTableTooling';
import LocaleTooling from '../../../tooling/localeTooling';
import { intl } from '../../../locales/localesConfig';

/* Actions */
import * as calculationUnitAdminActions from '../../actions/calculationUnitAdmin/index';
import * as dashboardActions from '../../actions/dashboard/index';

/*Components*/
import FullScreenGlassLoading from '../../components/common/interface/fullScreenGlassLoading';
import EntityHeader from '../../components/common/entity/entityHeader';
import EntityTable from '../../components/common/entity/entityTable';
import FormPopup from '../../components/calculationUnitAdmin/formPopup';
import EntityImportFormPopup from '../../components/common/entity/entityImportFormPopup';
import ImportExtraInfoPopup from '../../components/calculationUnitAdmin/importExtraInfoPopup';
import GlassConfirmPopup from '../../components/common/interface/glassConfirmPopup';
import Select from '../../components/common/inputs/select';
import ErrorLoadingView from '../../components/common/interface/errorLoadingView';
import CheckBox from '../../components/common/inputs/checkBox';

const popupIds = {
  importExtraInfoPopup: "importExtraInfoPopup",
  closeFormConfirmPopup: "closeFormConfirmPopup",
}

class CalculationUnitAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      topControlsFormData: {
        searchText: '',
        showDisabledEntities: false,
        periodIdSelected: '',
        showAuditColumn: false,
      },
      searchTimeoutObject: null,
      tableDescriptor: TableDescriptors.calculationUnitList,
      entityApiKey: "calculation_unit",
      initialNewEntity: { empty_object: true, is_unknown_calculation_unit: false },
      formHasChanges: false,
    };
  }
 
  async componentDidMount() {
    await this.props.actions.getPeriodsList();
  }
  
  componentWillUnmount() {
    this.props.actions.reset();
  }
  
  componentDidUpdate(prevProps) {
    EntityTableTooling.feedbackMessages(this, prevProps, 
      FormatTooling.toUpperCaseFirst(LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id: "calculationUnitAdmin.entityNameSingular"}))),
      FormatTooling.toUpperCaseFirst(LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id: "calculationUnitAdmin.entityNamePlural"}))),
      intl.formatMessage({id: "calculationUnitAdmin.genderVocal"}),
      this.props.delete.errors.message ? intl.formatMessage({id: "common.errors.detailLabel"}) + this.props.delete.errors.message : "");
    
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.systemDimensionMetrics.status],
      [this.props.systemDimensionMetrics.status],
      null,
      LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id: "calculationUnitAdmin.errors.metric_loading"})),
      [() => {
        let metric_values_index = {}
        if(this.props.systemDimensionMetrics.data.collection) {
          this.props.systemDimensionMetrics.data.collection.forEach(item => {
            metric_values_index["m" + item.metric_version_id] = item;
          })
        }
        this.props.actions.setSaveEntityDataByKey("metric_values",metric_values_index);   
      }]    
    );
    
    if (this.props.periodsList.status===200 && prevProps.periodsList.status !==200) {
      if(this.props.periodsList.data.length > 0) {
        let periodIdSelected = this.props.periodsList.data[0].id;
        let selectedPeriod = null;
        if(this.props.match.params.periodId) {
          selectedPeriod = this.props.periodsList.data.find(item => item.id==this.props.match.params.periodId);
          periodIdSelected = selectedPeriod ? selectedPeriod.id : null;
        }
        if(this.props.fixedPeriodId!="") {
          selectedPeriod = this.props.periodsList.data.find(item => item.id==this.props.fixedPeriodId);
          periodIdSelected = selectedPeriod ? selectedPeriod.id : null;
        }
        this.state.topControlsFormData.periodIdSelected = periodIdSelected;
        this.props.actions.setPeriodId(periodIdSelected);
        EntityTableTooling.fetchList(this);
        this.props.handleCheckRouteAvailableTourReference(Constants.app.routes.calculationUnitAdmin)
      }
    }
  }
  
  getListQueryParams(defaultQueryParams) {
    let newQueryParams = defaultQueryParams;
    newQueryParams.fields_are = [];
    newQueryParams.searches_are = [];
    newQueryParams.active = !this.state.topControlsFormData.showDisabledEntities ? true : false;
    newQueryParams.period_id = this.state.topControlsFormData.periodIdSelected;
    return newQueryParams;
  }
  
  handleShowFormPopup = async (event) => {
    EntityTableTooling.handleShowFormPopup(this, event);
    if(!InterfaceTooling.popupHasToRender(EntityTableTooling.getFormPopupState(this))) { 
      if(event.currentTarget.dataset.entitydata) {
        var entityObject = JSON.parse(event.currentTarget.dataset.entitydata)
        this.props.actions.getSystemDimensionMetrics({
          system_dimension_instance: entityObject.id,
          period_id: this.state.topControlsFormData.periodIdSelected,
          system_dimension_class: Constants.systemDimensionsIdentifiers.calculationUnit
        });
      }
      else {
        this.props.actions.getSystemDimensionMetrics({
          system_dimension_class: Constants.systemDimensionsIdentifiers.calculationUnit
        });
      }
    }
  };

  handleDownloadImportSheet = async () => {
    await this.props.actions.downloadImportFile({
      period_id: this.state.topControlsFormData.periodIdSelected,
      active: !document.getElementById('import_include_deactivated').checked,
      import_method: document.getElementById('import_method').value
    });
  };

  handleOnSaveImportForm = async (event) => {
    let files = [];
    files = document.getElementById('import_file').files;
    files = Object.keys(files).map(key => files[key]);
    document.getElementById('import_file').value = '';
    await this.props.actions.importEntities(files, {
      period_id: this.state.topControlsFormData.periodIdSelected,
      import_method: document.getElementById('import_method').value,
      import_exclude_calculation_units_unrollment: document.getElementById('import_exclude_calculation_units_unrollment').checked
    });
  };

  handleRefreshImportExtraInfoPopup = event => {
    this.props.actions.getImportCalculationUnitsNotifications(this.state.topControlsFormData.periodIdSelected);
  };

  handleImportExtraInfoPopup = event => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.importExtraInfoPopup, this.state, 
      this.setState.bind(this), this.props.importCalculationUnitsNotifications.loading, () => {
        this.props.actions.getImportCalculationUnitsNotifications(this.state.topControlsFormData.periodIdSelected);
      }
    );
  };

  handleImportExtraInfoPopupNextPage = async (event) => {
    var page = +event.currentTarget.dataset.targetpage;
    if(this.props.importCalculationUnitsNotifications.status === 200 && 
       this.props.importCalculationUnitsNotifications.page<=this.props.importCalculationUnitsNotifications.totalPages) {
      await this.props.actions.getImportCalculationUnitsNotifications(this.state.topControlsFormData.periodIdSelected, page);
    }  
  };

  handleOnChangeForm = (event) => {
    if(event.currentTarget.dataset.path == "calculation_unit.is_unknown_calculation_unit" &&
    JavascriptUtilsTooling.getInputValueFromEvent(event) == true) {
      this.props.actions.setSaveEntityDataByKey("calculation_unit.code", Constants.unknownCalculationUnitCode);
    }
    EntityTableTooling.handleOnChangeForm(this, event);
  };

  render() {
    var loadingView = this.props.periodsList.firstLoading || (this.props.list.firstLoading && this.props.periodsList.status == 200 && this.props.periodsList.data.length>0);
    var errorLoadingView = (this.props.periodsList.status !== null && this.props.periodsList.status !== 200) ||
        (this.props.list.status !== null && this.props.list.status !== 200);
    var noPeriodsCreated = this.props.periodsList.status == 200 && this.props.periodsList.data.length==0;
    return (
      <section className="dashboard_content_inner_view entity_admin_container calculation_unit_admin_container">
        {
          loadingView ? (<FullScreenGlassLoading/>) : 
          noPeriodsCreated ? (
            <section>
              <EntityHeader 
                entityNamePlural={this.state.tableDescriptor.entityNamePlural}
                entityNameSingular={this.state.tableDescriptor.entityNameSingular}
              />
              <div className="no_period_selected_wrapper">
                {intl.formatMessage({ id: "common.noPeriodCreated" })}
              </div>
            </section>            
          ) :
          (this.state.topControlsFormData.periodIdSelected == null) ? (
            <section>
              <EntityHeader 
                entityNamePlural={this.state.tableDescriptor.entityNamePlural}
                entityNameSingular={this.state.tableDescriptor.entityNameSingular}
              />
              <div className="no_period_selected_wrapper">
                {intl.formatMessage({ id: "common.periodNotFounded" })}
              </div>
            </section>            
          ) :
          errorLoadingView ? (<ErrorLoadingView/>) :
          (
            <section>
              <EntityHeader 
                entityNamePlural={this.state.tableDescriptor.entityNamePlural}
                entityNameSingular={this.state.tableDescriptor.entityNameSingular}
                handleFormPopup={this.handleShowFormPopup}
                handleImportFormPopup={EntityTableTooling.handleShowImportFormPopup.bind(null, this)}
                handleRefresh={EntityTableTooling.fetchList.bind(null, this)}
                handleImportExtraInfoPopup={this.handleImportExtraInfoPopup}
              />
              <EntityTable
                entityTableDescriptor={this.state.tableDescriptor}
                data={this.props.list.data}
                loading={this.props.list.loading}
                page={this.props.list.page}
                totalPages={this.props.list.totalPages}
                totalRecords={this.props.list.totalRecords}
                orderBy={this.props.list.orderBy}
                orderByDirection={this.props.list.orderByDirection}
                topControlsFormData={this.state.topControlsFormData}
                handleOnChangeTopControls={EntityTableTooling.handleOnChangeTopControls.bind(null, this)}
                fetchOrderList={EntityTableTooling.fetchListOrder.bind(null, this)}
                fetchListChangePage={EntityTableTooling.fetchListNextPage.bind(null, this)}
                handleShowFormPopup={this.handleShowFormPopup}
                handleDelete={EntityTableTooling.handleDeletePopup.bind(null, this)}
                handleActive={EntityTableTooling.handleActivePopup.bind(null, this)}
                extraControls={
                  <div>
                    <Select 
                      className="top_controls_period_selected"
                      disabled={this.props.fixedPeriodId!=""}
                      id="periodIdSelected"
                      value={this.state.topControlsFormData.periodIdSelected}
                      onChange={EntityTableTooling.handleOnChangeTopControls.bind(null, this)}
                      labelLocale={<FormattedMessage id="common.periodSelectLabel"/>}
                      options={InterfaceTooling.getSelectArrayFromArrayOfObjects(this.props.periodsList.data, "id", "name", false)}
                    />
                  </div>
                }
                handleShowAuditPopup={this.props.handleNotificationDetailPopupReference}
              />
              <FormPopup
                handleShowPopup={EntityTableTooling.handleShowFormPopupWithConfirmOnExit.bind(null, this)}
                handleOnChangeForm={this.handleOnChangeForm}
                handleButton={EntityTableTooling.handleOnSaveForm.bind(null, this)}
                loadingButton={this.props.save.loading}
                fullLoading={this.props.save.loading || this.props.systemDimensionMetrics.loading}
                metricsStatus={this.props.systemDimensionMetrics.status}
                metricsOptionsLists={this.props.systemDimensionMetrics.data.dimensionInstances}
                statusButton={this.props.save.status}
                formData={this.props.save.data}
                errors={this.props.save.errors}
                entityNameSingular={this.state.tableDescriptor.entityNameSingular}
                popupState={EntityTableTooling.getFormPopupState(this)}
              />
              <EntityImportFormPopup
                handleShowPopup={EntityTableTooling.handleShowImportFormPopup.bind(null, this)}
                handleDownloadImportSheet={this.handleDownloadImportSheet}
                handleButton={this.handleOnSaveImportForm}
                loadingButton={this.props.import.loading}
                fullLoading={this.props.import.loading || this.props.downloadImport.loading}
                statusButton={this.props.import.status}
                errors={this.props.import.errors}
                entityNamePlural={this.state.tableDescriptor.entityNamePlural}
                genderVocal={this.state.tableDescriptor.genderVocal}
                popupState={EntityTableTooling.getImportPopupState(this)}
                additionalControls={(
                  <React.Fragment>
                    <Select 
                      id="import_method"
                      labelLocale={<FormattedMessage id="calculationUnitAdmin.importFields.importMethod"/>}
                      options={InterfaceTooling.getSelectArray("selectKeys.calculationUnit.importMethod","calculationUnitAdmin.importFields.importMethodOptions", false)}
                    />
                    <CheckBox
                      id="import_exclude_calculation_units_unrollment"                        
                      labelLocale={LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id="calculationUnitAdmin.importFields.importExcludeCalculationUnitsUnenrollment"/>)}
                    />
                  </React.Fragment>
                )}
              />              
              <ImportExtraInfoPopup
                handleShowPopup={this.handleImportExtraInfoPopup}
                handleRefresh={this.handleRefreshImportExtraInfoPopup}
                fullLoading={this.props.importCalculationUnitsNotifications.firstLoading}
                tableLoading={this.props.importCalculationUnitsNotifications.loading}
                listState={this.props.importCalculationUnitsNotifications}
                handleNextPage={this.handleImportExtraInfoPopupNextPage}
                handleRowClick={this.props.handleNotificationDetailPopupReference}
                popupState={this.state[popupIds.importExtraInfoPopup]}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage 
                 id={"common.entity.deleteEntityConfirmTitle"}
                 values={{entityNameSingular: (LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id={"calculationUnitAdmin.entityNameSingular"}/>))}}
                />)}
                confirmText={(<FormattedMessage 
                 id={"common.entity.deleteEntityConfirm"}
                 values={{entityNameSingular: (LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id={"calculationUnitAdmin.entityNameSingular"}/>))}}
                />)}
                handleConfirm={EntityTableTooling.handleDeleteConfirm.bind(null, this)}
                handleCancel={EntityTableTooling.handleDeletePopup.bind(null, this)}
                popupState={EntityTableTooling.getDeletePopupState(this)}
                loading={this.props.delete.loading}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage 
                 id={"common.entity.activeEntityConfirmTitle"}
                 values={{
                    entityNameSingular: (LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id={"calculationUnitAdmin.entityNameSingular"}/>)),
                    activeAction: this.props.save.data.calculation_unit && this.props.save.data.calculation_unit.active ?
                      (<FormattedMessage id={"common.entity.activeAction"}/>) :
                      (<FormattedMessage id={"common.entity.deactiveAction"}/>)
                  }}
                />)}
                confirmText={(<FormattedMessage 
                 id={"common.entity.activeEntityConfirm"}
                 values={{
                    entityNameSingular: (LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id={"calculationUnitAdmin.entityNameSingular"}/>)),
                    activeAction: this.props.save.data.calculation_unit && this.props.save.data.calculation_unit.active ?
                      (<FormattedMessage id={"common.entity.activeAction"}/>) :
                      (<FormattedMessage id={"common.entity.deactiveAction"}/>)
                  }}
                />)}
                handleConfirm={EntityTableTooling.handleActiveConfirm.bind(null, this)}
                handleCancel={EntityTableTooling.handleActivePopup.bind(null, this)}
                popupState={EntityTableTooling.getActivePopupState(this)}
                loading={this.props.save.loading}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage id={"common.confirmExitPopupTitle"}/>)}
                confirmText={(<FormattedMessage id={"common.confirmExitPopupDetail"}/>)}
                handleConfirm={InterfaceTooling.handleCloseForm.bind(null, this)}
                handleCancel={InterfaceTooling.handleCloseFormConfirmPopup.bind(null, this)}
                popupState={InterfaceTooling.getCloseFormConfirmPopupState(this)}
                loading={false}
              />
            </section>
          )
        }
      </section>
    );
  }
}

const mapStateToProps = state => ({
  list: state.reducer.calculationUnitAdmin.list,
  save: state.reducer.calculationUnitAdmin.save,
  delete: state.reducer.calculationUnitAdmin.delete,
  systemDimensionMetrics: state.reducer.calculationUnitAdmin.systemDimensionMetrics,
  import: state.reducer.calculationUnitAdmin.import,
  downloadImport: state.reducer.calculationUnitAdmin.downloadImport,
  importCalculationUnitsNotifications: state.reducer.calculationUnitAdmin.importCalculationUnitsNotifications,
  periodsList: state.reducer.calculationUnitAdmin.periodsList,
  periodId: state.reducer.calculationUnitAdmin.periodId,
  fixedPeriodId: state.reducer.dashboard.fixedPeriodId,
  handleNotificationDetailPopupReference: state.reducer.dashboard.handleNotificationDetailPopupReference,
  handleCheckRouteAvailableTourReference: state.reducer.dashboard.handleCheckRouteAvailableTourReference,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(calculationUnitAdminActions, dispatch),
  dashboardActions: bindActionCreators(dashboardActions, dispatch)
});

CalculationUnitAdmin.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CalculationUnitAdmin);



// WEBPACK FOOTER //
// ./source/client/containers/calculationUnitAdmin/index.jsx